import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import Result from "../../Result/index";
import { getTimeBetweenInSec } from "utils/dateUtils";
import moment from "moment";

const ResultContent = ({ data, saveSafeplaceResult }) => {
	const [fastResultHasScannedQR, setFastResultHasScannedQR] = useState(false);
	const [waitTimer, setWaitTimer] = useState(true);

	const hasTubeWithResults = (tubes) => {
		return tubes ? tubes.some((t) => t.properties.timer_before_result > 0) : false;
	};
	const tubeWithTimerBeforeResult = (tubes) => {
		if (hasTubeWithResults(tubes)) return tubes.filter((t) => t.properties.timer_before_result > 0)[0];
	};
	const checkfastResultQRCode = (qrcode) => {
		if (data.tubes?.filter((t) => t.provider_barcode === qrcode).length > 0) setFastResultHasScannedQR(true);
	};

	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			<Result
				result={data.prescriptions?.length > 0 ? data.prescriptions[0].safeplace_result : ""}
				timer={
					tubeWithTimerBeforeResult(data.tubes) && tubeWithTimerBeforeResult(data.tubes).sampling_time
						? getTimeBetweenInSec(
								moment(tubeWithTimerBeforeResult(data.tubes).sampling_time).add(
									tubeWithTimerBeforeResult(data.tubes).properties.timer_before_results,
									"m"
								)
						  )
						: 0
				}
				hasScannedQR={fastResultHasScannedQR}
				checkQR={checkfastResultQRCode}
				saveResult={saveSafeplaceResult}
				setNotWaitingTimer={() => setWaitTimer(false)}
				waitTimer={waitTimer}
				disabled={data.isDone}
				tube={tubeWithTimerBeforeResult(data.tubes)}
			/>
		</Tab.Pane>
	);
};
export default ResultContent;
